/** Sprinklr draft surveys auto-populate QUESTION_HINT with this placeholder when unset. */
const SPRINKLR_DEFAULT_QUESTION_HINT = 'QUESTION HINT';

export function shouldShowQuestionHint(hint?: string | null): boolean {
  if (!hint) return false;
  const plain = hint.replace(/<[^>]*>/g, '').trim();
  return plain.toUpperCase() !== SPRINKLR_DEFAULT_QUESTION_HINT;
}
